"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiRequest = void 0;
exports.fetchCommonData = fetchCommonData;
exports.fetchCommonDataV2 = fetchCommonDataV2;
exports.commonDataProviderSaga = commonDataProviderSaga;
/* eslint-disable prefer-promise-reject-errors */
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../LanguagesProvider/selectors");
const types_1 = require("../ConfigProvider/types");
const index_1 = require("../../api/index");
const saga_1 = require("../ConfigProvider/saga");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/commonData/api");
const slice_1 = require("./slice");
const selectors_2 = require("./selectors");
const commonDataRequests = (payload, apis, 
// TODO remove after ENTITY_TAGS release
featureFlags) => {
    const requests = [
        () => apis.sportsApi.getSports(payload),
        () => apis.outcomeCategoriesApi.getOutcomeCategories(payload),
        () => apis.marketsApi.getMarkets(payload),
        () => apis.currenciesApi.getCurrencies(payload),
        () => apis.marketCategoriesApi.getMarketCategories(payload),
        () => apis.marketGroupsApi.getMarketGroups(payload),
        () => apis.systemCurrenciesApi.getSystemCurrencies(payload),
        () => apis.matchPhasesApi.getMatchPhases(payload),
        () => apis.eventProbabilitiesApi.getHotProbabilityGroups(payload),
    ];
    // TODO remove after ENTITY_TAGS release
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.isEntityTagsEnabled) {
        requests.push(() => apis.entityTagsApi.getEntityTags(payload));
    }
    // TODO remove after NEW_OUTCOMES_ENABLED release
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.newOutcomesEnabled) {
        requests.push(() => apis.virtualCategoriesApi.getVirtualCategories(payload));
    }
    return requests;
};
function* fetchCommonDataDeprecated(action) {
    try {
        const sportsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.SportsApi);
        const outcomeCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.OutcomeCategoriesApi);
        const marketsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketsApi);
        const currenciesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.CurrenciesApi);
        const marketCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketCategoriesApi);
        const marketGroupsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketGroupsApi);
        const entityTagsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.EntityTagsApi);
        const systemCurrenciesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.SystemCurrenciesApi);
        const matchPhasesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MatchPhasesApi);
        const eventProbabilitiesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.EventProbabilitiesApi);
        const virtualCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualCategoriesApi);
        const apis = {
            sportsApi,
            outcomeCategoriesApi,
            marketsApi,
            currenciesApi,
            marketCategoriesApi,
            marketGroupsApi,
            systemCurrenciesApi,
            matchPhasesApi,
            eventProbabilitiesApi,
            entityTagsApi,
            virtualCategoriesApi,
        };
        // TODO remove after ENTITY_TAGS release
        const isEntityTagsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.ENTITY_TAGS_ENABLED);
        // TODO remove after NEW_OUTCOMES_ENABLED release
        const newOutcomesEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
        const currentLangCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const reqPayload = { locale: currentLangCode };
        const [sportsPayload, outcomeCategoriesPayload, marketsPayload, currenciesPayload, marketCategoriesPayload, marketGroupsPayload, systemCurrenciesPayload, matchPhasesPayload, eventProbabilitiesPayload, entityTagsPayload, virtualCategoriesPayload,] = yield Promise.all(commonDataRequests(reqPayload, apis, {
            isEntityTagsEnabled,
            newOutcomesEnabled,
        }).map((commonDataRequest) => commonDataRequest()));
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataSuccess({
            entries: {
                sports: sportsPayload.data,
                outcomeCategories: outcomeCategoriesPayload.data,
                markets: marketsPayload.data,
                currencies: currenciesPayload.data,
                marketCategories: marketCategoriesPayload.data,
                marketGroups: marketGroupsPayload.data,
                systemCurrencies: systemCurrenciesPayload.data,
                matchPhases: matchPhasesPayload.data,
                hotProbabilitiesGroups: eventProbabilitiesPayload.data,
                // TODO edit after ENTITY_TAGS release
                entityTags: (entityTagsPayload === null || entityTagsPayload === void 0 ? void 0 : entityTagsPayload.data) || { items: [] },
                // TODO edit after NEW_OUTCOMES_ENABLED release
                virtualCategories: (virtualCategoriesPayload === null || virtualCategoriesPayload === void 0 ? void 0 : virtualCategoriesPayload.data) || {
                    items: [],
                },
            },
            fromServer: !!action.payload.fromServer,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error fetching common data', error);
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataError(error));
    }
}
function* fetchCommonData(action) {
    const isFetchNewCommonDataEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.FETCH_COMMON_DATA_NEW);
    if (isFetchNewCommonDataEnabled) {
        yield (0, effects_1.fork)(fetchCommonDataNew, action);
    }
    else {
        yield (0, effects_1.fork)(fetchCommonDataDeprecated, action);
    }
}
const getApiRequest = (entryKey, reqPayload) => {
    const sportsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.SportsApi);
    const outcomeCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.OutcomeCategoriesApi);
    const marketsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketsApi);
    const currenciesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.CurrenciesApi);
    const marketCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketCategoriesApi);
    const marketGroupsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MarketGroupsApi);
    const entityTagsApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.EntityTagsApi);
    const systemCurrenciesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.SystemCurrenciesApi);
    const matchPhasesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.MatchPhasesApi);
    const eventProbabilitiesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.EventProbabilitiesApi);
    const virtualCategoriesApi = index_1.ApiManager.getApi(betweb_openapi_axios_1.VirtualCategoriesApi);
    switch (entryKey) {
        case 'sports': {
            return new Promise((resolve, reject) => {
                sportsApi
                    .getSports(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'outcomeCategories': {
            return new Promise((resolve, reject) => {
                outcomeCategoriesApi
                    .getOutcomeCategories(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'markets': {
            return new Promise((resolve, reject) => {
                marketsApi
                    .getMarkets(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'currencies': {
            return new Promise((resolve, reject) => {
                currenciesApi
                    .getCurrencies(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'marketCategories': {
            return new Promise((resolve, reject) => {
                marketCategoriesApi
                    .getMarketCategories(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'marketGroups': {
            return new Promise((resolve, reject) => {
                marketGroupsApi
                    .getMarketGroups(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'systemCurrencies': {
            return new Promise((resolve, reject) => {
                systemCurrenciesApi
                    .getSystemCurrencies(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'matchPhases': {
            return new Promise((resolve, reject) => {
                matchPhasesApi
                    .getMatchPhases(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'hotProbabilitiesGroups': {
            return new Promise((resolve, reject) => {
                eventProbabilitiesApi
                    .getHotProbabilityGroups()
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'entityTags': {
            return new Promise((resolve, reject) => {
                entityTagsApi
                    .getEntityTags()
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        case 'virtualCategories': {
            return new Promise((resolve, reject) => {
                virtualCategoriesApi
                    .getVirtualCategories(reqPayload)
                    .then(({ data }) => resolve({ entryKey, data }))
                    .catch(() => reject({ entryKey, data: { items: [] } }));
            });
        }
        default:
            throw new Error(`Unhandled entryKey case: ${entryKey}`);
    }
};
exports.getApiRequest = getApiRequest;
const isFulfilled = (p) => p.status === 'fulfilled';
const mapCommonDataResponses = (res) => {
    if (isFulfilled(res)) {
        return res.value;
    }
    else {
        return res.reason;
    }
};
function* settleCommonDataPromises(promises) {
    return (yield Promise.allSettled(promises))
        .map(mapCommonDataResponses)
        .reduce((acc, cur) => {
        acc[cur.entryKey] = cur.data;
        return acc;
    }, {});
}
function* fetchCommonDataNew(action) {
    try {
        const currentLangCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const reqPayload = { locale: currentLangCode };
        // TODO remove after NEW_OUTCOMES_ENABLED release
        const newOutcomesEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
        const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
        const promises = [
            (0, exports.getApiRequest)('sports', reqPayload),
            (0, exports.getApiRequest)('outcomeCategories', reqPayload),
            (0, exports.getApiRequest)('markets', reqPayload),
            (0, exports.getApiRequest)('currencies', reqPayload),
            (0, exports.getApiRequest)('marketGroups', reqPayload),
            (0, exports.getApiRequest)('systemCurrencies', reqPayload),
            (0, exports.getApiRequest)('matchPhases', reqPayload),
            (0, exports.getApiRequest)('hotProbabilitiesGroups', reqPayload),
            (0, exports.getApiRequest)('entityTags', reqPayload),
        ];
        if (newOutcomesEnabled) {
            promises.push((0, exports.getApiRequest)('virtualCategories', reqPayload));
        }
        else {
            promises.push((0, exports.getApiRequest)('marketCategories', reqPayload));
        }
        const result = yield (0, effects_1.call)(settleCommonDataPromises, promises);
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataSuccessNew({
            fromServer: !!action.payload.fromServer,
        }));
        if (newOutcomesStructEnabled) {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntriesV2({
                entries: result,
            }));
        }
        else {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntries({
                entries: result,
            }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching common data', error);
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataError(error));
    }
}
function* refetchCommonData() {
    const currentLangCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    const reqPayload = { locale: currentLangCode };
    const all = yield (0, effects_1.select)(selectors_2.selectIsAllCommonDataLoaded);
    if (!all) {
        const entries = yield (0, effects_1.select)(selectors_2.getCommonDataEntries);
        const loadedInfo = (0, selectors_2.selectLoadedOrNotCommonData)(entries);
        const keys = Object.keys(loadedInfo);
        const promises = [];
        keys.forEach((key) => {
            const loaded = loadedInfo[key];
            if (!loaded) {
                promises.push((0, exports.getApiRequest)(key, reqPayload));
            }
        });
        const result = yield (0, effects_1.call)(settleCommonDataPromises, promises);
        const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
        if (newOutcomesStructEnabled) {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntriesV2({
                entries: result,
            }));
        }
        else {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntries({
                entries: result,
            }));
        }
    }
}
/* Retriable common data fetching for SPA approach */
function* fetchCommonDataV2(action) {
    try {
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const options = action.payload;
        const reqPayload = { locale };
        const newOutcomesEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
        const apisToExclude = new Set();
        if (!newOutcomesEnabled) {
            apisToExclude.add('virtualCategories');
        }
        else {
            apisToExclude.add('marketCategories');
        }
        const result = yield (0, effects_1.call)(api_1.getCommonData, options, reqPayload, apisToExclude);
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataSuccessNew({
            fromServer: false,
        }));
        const newOutcomesStructEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
        if (newOutcomesStructEnabled) {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntriesV2({
                entries: result,
            }));
        }
        else {
            yield (0, effects_1.put)(slice_1.commonDataProviderActions.setCommonDataEntries({
                entries: result,
            }));
        }
    }
    catch (err) {
        console.error('Error fetching common data:', err);
        const error = (0, errors_1.getErrorOrUnknown)(err);
        yield (0, effects_1.put)(slice_1.commonDataProviderActions.fetchCommonDataError(error));
    }
}
function* commonDataProviderSaga() {
    yield (0, effects_1.takeLatest)(slice_1.commonDataProviderActions.fetchCommonData.type, fetchCommonData);
    yield (0, effects_1.takeLatest)(slice_1.commonDataProviderActions.refetchCommonData.type, refetchCommonData);
    yield (0, effects_1.takeLatest)(slice_1.commonDataProviderActions.fetchCommonDataV2.type, fetchCommonDataV2);
}
//# sourceMappingURL=saga.js.map